/* MISS BULLITT — rider sprite.
   Traced from the colour decal artwork (Asset 1); one rect = one pixel, so
   this is the bike exactly as drawn on the frame, not a redraw.
   Stored facing RIGHT as drawn. The engine rotates it 90 degrees per
   heading; rotating pixel data is exact, so nothing resamples or blurs.
   Tones: 0 = shade, 1 = base, 2 = accent, recoloured per rider. */
window.MB_BIKE = {
  w: 33, h: 12,
  rows: [
      ".................0...............",
      "..............0000...............",
      ".........0000011100000000000.....",
      "........011111110101110111010....",
      "..0000001110000011011101110110...",
      ".02222011101111201011101110111000",
      ".02222011101111201011101110111000",
      "..0000001110000011000000000110.0.",
      "........01111111010111011101000..",
      ".........00000111000000000000....",
      "..............0000...............",
      ".................0..............."
  ]
};